import { render, staticRenderFns } from "./createQz.vue?vue&type=template&id=21408d97&scoped=true"
import script from "./createQz.vue?vue&type=script&lang=js"
export * from "./createQz.vue?vue&type=script&lang=js"
import style0 from "./createQz.vue?vue&type=style&index=0&id=21408d97&prod&lang=css"
import style1 from "./createQz.vue?vue&type=style&index=1&id=21408d97&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21408d97",
  null
  
)

export default component.exports